<template>
  <nav class="h-crumb" aria-label="Breadcrumb">
    <template v-for="(item, i) in items" :key="i">
      <span v-if="i > 0" class="h-crumb__sep" aria-hidden="true">/</span>
      <router-link
        v-if="item.to && i < items.length - 1"
        class="h-crumb__link"
        :to="item.to"
      >{{ item.label }}</router-link>
      <a
        v-else-if="item.href && i < items.length - 1"
        class="h-crumb__link"
        :href="item.href"
      >{{ item.label }}</a>
      <span
        v-else
        :class="i === items.length - 1 ? 'h-crumb__current' : 'h-crumb__text'"
        :aria-current="i === items.length - 1 ? 'page' : null"
      >{{ item.label }}</span>
    </template>
  </nav>
</template>

<script>
// Topbar breadcrumbs — the last item is the current page (bold), earlier ones
// are muted, optionally linked. Matches the .crumb treatment in navigation.html.
export default {
  name: 'HermesBreadcrumbs',
  props: {
    // [{ label, to?, href? }] — `to` uses router-link, `href` a plain anchor.
    items: { type: Array, default: () => [] },
  },
};
</script>

<style scoped>
.h-crumb { display: flex; align-items: center; gap: 8px; font-family: var(--h-font-body, system-ui); font-size: 13px; color: var(--h-text-secondary, #64748B); }
.h-crumb__sep { color: var(--h-text-tertiary, #94A3B8); }
.h-crumb__text { color: var(--h-text-secondary, #64748B); }
.h-crumb__current { color: var(--h-text-primary, #0F172A); font-weight: 600; }
.h-crumb__link { color: var(--h-text-secondary, #64748B); text-decoration: none; }
.h-crumb__link:hover { color: var(--h-accent-dark, #0369A1); text-decoration: underline; }
.h-crumb__link:focus-visible { outline: none; box-shadow: var(--h-focus-ring); border-radius: 3px; }
</style>
